// @flow

const CookieConstants = {
  HAS_SEEN_LIMITED_CLASSES_MODAL: 'has_seen_limited_classes_modal',
};

export default CookieConstants;
